import { ValidateField, ExponentialToDecimal, FieldHasValue } from 'helpers/Validation';

export const AsFoundTestTableDeviationEu1Formula = (formData) => FieldHasValue(formData.F300SwitchSetpoint) && FieldHasValue(formData.F181AftTestEquipmentIndication)
    ? ExponentialToDecimal(Math.abs(ValidateField(formData.F300SwitchSetpoint) - ValidateField(formData.F181AftTestEquipmentIndication))) : '';
